<template>
    <div>
        <div v-if="Permission.CREATE_AGENCY && $page.props.agency.can_create_agencies"
             class="d-flex flex-row justify-content-end mb-3">
            <Link :href="$route('agency.create')"
                  as="button"
                  class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-icon-primary btn-hover-primary font-weight-bolder font-size-sm px-5 my-1 ml-3">
                    <span class="svg-icon svg-icon-md">
                        <i class="fas fa-plus"/>
                    </span>
                {{ __('agency.create') }}
            </Link>
        </div>

        <CurrentAgency class="mb-2"/>

        <div class="card card-body">
            <table class="table table-hover">
                <thead>
                <tr>
                    <th>{{ __('general.agency') }}</th>
                    <th class="text-center">Kann sub-agenturen anlegen</th>
                    <th class="text-right">{{ __('general.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="agency in agencies">
                    <td>
                        <div class="d-flex flex-row align-items-center">
                            <div class="symbol mr-3">
                            <span class="symbol-label font-size-h6 ${text}"
                                  :style="`background-color: #${agency.color};`">
                                {{ agency.name.substring(0, 1).toUpperCase() }}
                            </span>
                            </div>
                            <div>
                                <div class="font-size-lg">{{ agency.name }}</div>
                                <span class="text-muted">#{{ agency.id }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="text-center">
                        <div class="d-flex flex-column justify-content-center h-3em">
                            <i v-if="agency.can_create_agencies" class="fas fa-check-circle"/>
                        </div>
                    </td>
                    <td class="text-right">
                        <Link v-if="Permission.MORPH_TO_AGENCY"
                              as="button"
                              :href="$route('agency.morph',[agency.id])"
                              class="btn btn-light-info">
                            <i class="fas fa-sign-in-alt mr-1"/>
                            {{ __('agency.enter') }}
                        </Link>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {PermissionsMixin} from "@js/permissions";
import { Link } from '@inertiajs/vue2';
import CurrentAgency from "@components/Agency/CurrentAgency.vue";

export default {
    components: {CurrentAgency, Link},

    mixins: [PermissionsMixin],

    props: {
        agencies: Array
    }
}
</script>
